module.exports = __webpack_public_path__ + "img/hangzhou.a3b90eed.png";